

const CampaignIcon = ({ width = "24", height = "24", ...props }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M4.31625 7.74756H7.45875V13.9538H4.31625C4.11734 13.9538 3.92658 13.8748 3.78592 13.7341C3.64527 13.5935 3.56625 13.4027 3.56625 13.2038V8.49756C3.56625 8.29865 3.64527 8.10788 3.78592 7.96723C3.92658 7.82658 4.11734 7.74756 4.31625 7.74756Z"
                stroke="#0069AD"
            />
            <path
                d="M7.45874 13.9536V7.74736C7.45874 7.74736 9.09749 7.78486 11.8237 7.74736C14.55 7.70986 17.7412 5.98486 19.815 4.22236C19.8692 4.17597 19.9356 4.14602 20.0062 4.13602C20.0769 4.12602 20.149 4.1364 20.2139 4.16594C20.2789 4.19547 20.3341 4.24293 20.373 4.30275C20.412 4.36256 20.433 4.43225 20.4337 4.50361V17.2124C20.4336 17.2823 20.4138 17.3509 20.3768 17.4102C20.3397 17.4695 20.2867 17.5173 20.2239 17.5481C20.1611 17.5789 20.0909 17.5916 20.0213 17.5846C19.9517 17.5776 19.8854 17.5513 19.83 17.5086C18.495 16.4586 15.1725 14.1111 11.955 14.0136C10.0725 13.9536 8.54999 13.9536 7.45874 13.9536Z"
                stroke="#0069AD"
            />
            <path
                d="M8.73375 19.875H6.93375C6.73483 19.875 6.54407 19.796 6.40342 19.6553C6.26276 19.5147 6.18375 19.3239 6.18375 19.125L5.80875 13.9575H9.10875L9.48375 19.125C9.48375 19.3239 9.40473 19.5147 9.26408 19.6553C9.12342 19.796 8.93266 19.875 8.73375 19.875Z"
                fill="#BBD8ED"
                stroke="#0069AD"
            />
            <line x1="7.46002" y1="8.25" x2="7.46002" y2="13.45" stroke="#00A7E4" />
        </svg>
    );
};

export default CampaignIcon;